import {firstMatchIndex} from '@/utils/helpCenter/searchArticles';
import {type HelpCenterArticle} from '@/utils/helpCenter/types';

export const SNIPPET_MAX_CHARS = 400;
const VISIBLE_CHARS = 180;

const CONTEXT_BEFORE_MATCH = 60;
const WORD_BOUNDARY_SEARCH = 20;

const articleSnippet = ({description, searchText}: HelpCenterArticle, query?: string): string => {
  const bodyMatch = query ? firstMatchIndex(searchText, query) : -1;
  const descriptionMatch = query ? firstMatchIndex(description, query) : -1;

  // Several live articles have no Intercom `description`, so the body is the default source.
  const useDescription = bodyMatch < 0 && descriptionMatch >= 0;
  const source = useDescription ? description : searchText || description;
  const matchIndex = useDescription ? descriptionMatch : bodyMatch;

  if (matchIndex < 0 || matchIndex <= VISIBLE_CHARS) return source.slice(0, SNIPPET_MAX_CHARS);

  const idealStart = matchIndex - CONTEXT_BEFORE_MATCH;
  const boundary = source.indexOf(' ', idealStart);
  const from =
    boundary > 0 && boundary - idealStart <= WORD_BOUNDARY_SEARCH ? boundary + 1 : idealStart;

  return `…${source.slice(from, from + SNIPPET_MAX_CHARS)}`;
};

export default articleSnippet;
